import { useState } from "react";
import { ConsoleShell, PageHead } from "../components/ConsoleShell.js";
import { Tabs, TabPanel, BtnLink } from "../components/index.js";
import { EmptyState } from "../components/EmptyState.js";
import { Icon } from "../components/Icon.js";

/**
 * 運用・信頼性。AI処理ジョブ / ストレージ / コスト / 監査ログの監視ビュー。
 *
 * 現時点では組織横断のジョブ一覧・ストレージ・コスト・監査ログを返す実APIが存在しない
 * (apps/api には per-manual の `/:id/status`(DO進捗プロキシ)はあるが、一覧/集計エンドポイントは未提供)。
 * 偽データは出さず、ConsoleShell + PageHead + タブ構造は維持したまま各パネルを正直な
 * 「準備中」表示にする。処理状況は当面マニュアル単位で確認できるため、ジョブタブからライブラリへ導線。
 */
export function Ops() {
  const [tab, setTab] = useState("jobs");
  return (
    <ConsoleShell breadcrumb={["TEBIKI", "運用"]}>
      <PageHead title={<>運用<span className="hl">・信頼性</span></>}>
        AI処理ジョブ・ストレージ・コスト・監査ログを一望できる運用ダッシュボードを準備しています。
      </PageHead>

      <Tabs
        active={tab}
        onChange={setTab}
        ariaLabel="運用ビュー"
        tabs={[
          { id: "jobs", label: "ジョブ" },
          { id: "storage", label: "ストレージ" },
          { id: "cost", label: "コスト/トークン" },
          { id: "audit", label: "監査ログ" },
        ]}
      />

      <div className="reveal d1">
        <TabPanel id="jobs" active={tab}>
          <EmptyState
            icon={<Icon name="ops" size={30} />}
            title="ジョブ監視は準備中です"
            action={
              <BtnLink to="/library" variant="primary" icon={<Icon name="library" />}>
                ライブラリで処理状況を見る
              </BtnLink>
            }
          >
            動画解析・翻訳などのAI処理ジョブを組織横断で一覧し、処理中の進捗確認や
            失敗ジョブ(DLQ)の再試行ができるようにします。現在はマニュアルごとの処理状況を
            ライブラリから確認できます。
          </EmptyState>
        </TabPanel>

        <TabPanel id="storage" active={tab}>
          <EmptyState icon={<Icon name="storage" size={30} />} title="ストレージ監視は準備中です">
            元動画・抽出フレーム・音声などR2に保存されたメディアの使用量と内訳を、
            組織・店舗単位でここに表示します。
          </EmptyState>
        </TabPanel>

        <TabPanel id="cost" active={tab}>
          <EmptyState icon={<Icon name="analytics" size={30} />} title="コスト / トークンの可視化は準備中です">
            Geminiの処理にかかったトークン消費と推定コストを、期間・マニュアル種別ごとに
            集計してここに表示します。
          </EmptyState>
        </TabPanel>

        <TabPanel id="audit" active={tab}>
          <EmptyState icon={<Icon name="audit" size={30} />} title="監査ログの閲覧は準備中です">
            作成・更新・承認・削除などの操作履歴を、実行者・対象・日時とともに
            検索・追跡できるようにします。
          </EmptyState>
        </TabPanel>
      </div>
    </ConsoleShell>
  );
}
